import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	text-align: center;
`;

export const Title = styled.h3`
	color: ${Colors.darkBlue};
	margin: 0;
`;

export const Description = styled.p`
	margin: 0;
	font-size: 14px;
`;

export const ReturnLink = styled.a`
	color: ${Colors.darkBlue};
	font-size: 14px;
`;
